import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { withIcon } from '../Icon';
export var StyledGoogleYellow = /*#__PURE__*/styled.path.withConfig({
  displayName: "StyledGoogleYellow",
  componentId: "c11n-8-111-1__sc-1hbb768-0"
})(["fill:#fbbc05;"]);
export var StyledGoogleRed = /*#__PURE__*/styled.path.withConfig({
  displayName: "StyledGoogleRed",
  componentId: "c11n-8-111-1__sc-1hbb768-1"
})(["fill:#ea4335;"]);
export var StyledGoogleGreen = /*#__PURE__*/styled.path.withConfig({
  displayName: "StyledGoogleGreen",
  componentId: "c11n-8-111-1__sc-1hbb768-2"
})(["fill:#34a853;"]);
export var StyledGoogleBlue = /*#__PURE__*/styled.path.withConfig({
  displayName: "StyledGoogleBlue",
  componentId: "c11n-8-111-1__sc-1hbb768-3"
})(["fill:#4285f4;"]);
export var GoogleSVG = function GoogleSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 20H24v9h12c-1 5-6 8-12 8a13 13 0 1 1 8-23l7-6A22 22 0 0 0 2 24c0 12 10 22 22 22 11 0 21-8 21-22v-4z"
  })), /*#__PURE__*/React.createElement(StyledGoogleYellow, {
    clipPath: "url(#a)",
    d: "M0 37V11l17 13z"
  }), /*#__PURE__*/React.createElement(StyledGoogleRed, {
    clipPath: "url(#a)",
    d: "M0 11l17 13 7-6 24-4V0H0z"
  }), /*#__PURE__*/React.createElement(StyledGoogleGreen, {
    clipPath: "url(#a)",
    d: "M0 37l30-23 8 1L48 0v48H0z"
  }), /*#__PURE__*/React.createElement(StyledGoogleBlue, {
    clipPath: "url(#a)",
    d: "M48 48L17 24l-4-3 35-10z"
  })));
};
GoogleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(GoogleSVG);